import type { VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { cn } from '@savvy-kit/lib/utils';
import { cva } from 'class-variance-authority';

const ribbonVariants = cva('relative w-full py-3 px-4 text-sm', {
  variants: {
    variant: {
      default: 'bg-card text-secondary',
      destructive: 'bg-destructive-background text-destructive-foreground-dark',
      warning: 'bg-warning-background text-warning-foreground-dark',
      info: 'bg-info-background text-info-foreground-dark',
      success: 'bg-success-background text-success-foreground-dark',
      contrast: 'bg-dark text-slate-300',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

type RibbonProps = React.ComponentProps<'div'> &
  VariantProps<typeof ribbonVariants> & {
    readonly description: React.ReactNode;
    readonly icon?: React.ReactNode;
    readonly actionButton?: React.ReactNode;
  };

function Ribbon({ className, variant, description, icon, actionButton, ...props }: RibbonProps) {
  return (
    <div data-slot="ribbon" role="status" className={cn(ribbonVariants({ variant }), className)} {...props}>
      <div className="flex flex-row justify-between items-center w-full gap-3">
        <div className="flex flex-row gap-3 flex-1 min-w-0">
          {icon && <div className="[&_svg]:size-4 my-0.5 shrink-0">{icon}</div>}
          <div data-slot="ribbon-description">{description}</div>
        </div>
        {actionButton && <div className="shrink-0">{actionButton}</div>}
      </div>
    </div>
  );
}

export { Ribbon, ribbonVariants };
export default Ribbon;
